import * as React from "react";
const SvgFiRrLungsVirus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-lungs-virus_svg__a)">
      <path
        fill="#062147"
        d="M11 6V1a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0M4.684 21.895a2.4 2.4 0 0 1-.686.105h-.003a2.01 2.01 0 0 1-1.412-.591A1.98 1.98 0 0 1 2 19.997c0-1.251.143-2.502.424-3.72L4.08 9.099a3.98 3.98 0 0 1 3.897-3.1 1 1 0 1 0 0-2A5.97 5.97 0 0 0 2.13 8.65L.475 15.828A18.6 18.6 0 0 0 0 19.997c0 1.07.415 2.074 1.17 2.827A4.03 4.03 0 0 0 3.996 24h.006c.448 0 .916-.075 1.314-.208a1 1 0 0 0-.633-1.898zm18.842-6.066L21.87 8.651A5.97 5.97 0 0 0 16.023 4a1 1 0 1 0 0 2 3.98 3.98 0 0 1 3.897 3.1l1.656 7.178c.281 1.217.424 2.468.424 3.719a1.98 1.98 0 0 1-.583 1.412 2.02 2.02 0 0 1-1.412.591c-.25-.01-.729-.131-.749-.137-.528-.14-1.034.171-1.188.688s.155 1.07.668 1.242c.41.137.836.207 1.263.208h.006a4.03 4.03 0 0 0 2.826-1.176 3.96 3.96 0 0 0 1.17-2.827c0-1.402-.16-2.805-.475-4.169m-7.717-3.223c.267.423.465.893.579 1.394H17a1 1 0 1 1 0 2h-.612a4.5 4.5 0 0 1-.579 1.394l.608.608Q16.458 18 16.5 18a1.5 1.5 0 1 1-1.498 1.417l-.608-.608a4.5 4.5 0 0 1-1.394.579V20a1 1 0 1 1-2 0v-.612a4.5 4.5 0 0 1-1.394-.579l-.608.608q.003.041.002.083a1.5 1.5 0 1 1-1.417-1.498l.608-.608A4.5 4.5 0 0 1 7.612 16H7a1 1 0 1 1 0-2h.612c.114-.502.313-.972.579-1.394l-.608-.608q-.041.003-.083.002A1.5 1.5 0 1 1 9 10.5q0 .042-.002.083l.608.608A4.5 4.5 0 0 1 11 10.612V10a1 1 0 1 1 2 0v.612c.502.114.972.313 1.394.579l.608-.608q-.003-.041-.002-.083a1.5 1.5 0 1 1 1.5 1.5q-.042 0-.083-.002zM14.501 15c0-1.378-1.121-2.5-2.5-2.5a2.503 2.503 0 0 0-2.5 2.5c0 1.378 1.121 2.5 2.5 2.5s2.5-1.122 2.5-2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-lungs-virus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLungsVirus;
